import { inject, Injectable } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AccountService } from '../../account/services/account.service';
import { LoadingService } from './loading.service';
import { AuthService } from './auth.service';
import { SharedStateService } from './shared-state.service';

@Injectable({
  providedIn: 'root'
})
export class RouterService {

  readonly #router = inject(Router);
  readonly #accountService = inject(AccountService);
  readonly #loadingService = inject(LoadingService);
  readonly #stateService = inject(SharedStateService);

  public init(): void {
    this.#router.events
    .subscribe({
      next: (evt) => {
        if(evt instanceof NavigationStart) {
          this.#loadingService.showLoadingIndicator();
        } else if (evt instanceof NavigationEnd) {
          this.#loadingService.hideLoadingIndicator();
          if(this.#stateService.IsLoggedIn()){
            this.#accountService.updateWebsiteTracker();
          }
          (window as any).gtag('config', 'G-NZWSMTWJ4Q', { page_path: evt.urlAfterRedirects });
        }
      }
    });

  }
}
